import React, { useState } from 'react';
import {
    AccordionContainer,
    AccordionItem,
    AccordionTitle,
    LoadingContainer,
    IconContainer
} from './Accordion.style';
import { icons } from 'seal-ui-components';

const Accordion = ({ title = '', children, isLoading, mixPanelEvent, ...rest }) => {
    const [isOpen, setOpen] = useState(false);

    const toggle = () => {
        if (mixPanelEvent) mixPanelEvent(isOpen);
        setOpen(!isOpen);
    };

    return (
        <AccordionContainer opened={isOpen}>
            <AccordionItem data-testid="accordion-item" onClick={toggle} {...rest}>
                <AccordionTitle>{title}</AccordionTitle>
                <LoadingContainer>{isLoading && <icons.LoadingMediumIcon />}</LoadingContainer>
                <IconContainer>
                    {isOpen ? <icons.ChevronUpSmallIcon /> : <icons.ChevronDownSmallIcon />}
                </IconContainer>
            </AccordionItem>
            {isOpen && children}
        </AccordionContainer>
    );
};

export default Accordion;
